import {
  FLOATING_PANEL_MIN_HEIGHT,
  FLOATING_PANEL_MIN_WIDTH,
  FLOATING_PANEL_VIEWPORT_MARGIN,
} from './dialog-resize.constants';
import { PanelSize, ResizeBounds } from './dialog-resize.interfaces';

export function buildResizeBounds(
  paneLeft: number,
  paneTop: number,
  viewportWidth: number,
  viewportHeight: number
): ResizeBounds {
  const maxWidth = Math.min(
    viewportWidth - paneLeft,
    viewportWidth - FLOATING_PANEL_VIEWPORT_MARGIN
  );
  const maxHeight = Math.min(
    viewportHeight - paneTop,
    viewportHeight - FLOATING_PANEL_VIEWPORT_MARGIN
  );

  return {
    minWidth: FLOATING_PANEL_MIN_WIDTH,
    minHeight: FLOATING_PANEL_MIN_HEIGHT,
    maxWidth: Math.max(FLOATING_PANEL_MIN_WIDTH, maxWidth),
    maxHeight: Math.max(FLOATING_PANEL_MIN_HEIGHT, maxHeight),
  };
}

export function clampPanelSize(
  size: PanelSize,
  bounds: ResizeBounds
): PanelSize {
  return {
    width: Math.min(Math.max(size.width, bounds.minWidth), bounds.maxWidth),
    height: Math.min(Math.max(size.height, bounds.minHeight), bounds.maxHeight),
  };
}
